import React from 'react'
import { IconsModel } from './types/iconsModel'
import { WHITE } from '../theme'

const SvgCircledRightArrow = (
	{
		color,
		secondColor,
		thirdColor = WHITE,
		width = 55,
		height = 55
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 55 55">
		<g id="Groupe_648" data-name="Groupe 648" transform="translate(0 55) rotate(-90)">
			<g id="Ellipse_43" data-name="Ellipse 43" transform="translate(0 0)" fill={color} stroke={secondColor} strokeWidth="2">
				<circle cx="27.5" cy="27.5" r="27.5" stroke="none" />
				<circle cx="27.5" cy="27.5" r="26.5" fill="none" />
			</g>
			<g id="Groupe_190" data-name="Groupe 190" transform="translate(18.967 15.476)">
				<line id="Ligne_28" data-name="Ligne 28" y1="23.941" transform="translate(8.379)" fill="none" stroke={thirdColor} strokeWidth="2" />
				<line id="Ligne_29" data-name="Ligne 29" x1="8.379" y1="8.379" transform="translate(0 15.861)" fill="none" stroke={thirdColor} strokeWidth="2" />
				<line id="Ligne_30" data-name="Ligne 30" y1="8.379" x2="8.679" transform="translate(8.08 15.861)" fill="none" stroke={thirdColor} strokeWidth="2" />
			</g>
		</g>
	</svg>

)

export default SvgCircledRightArrow
